import { FC, useContext } from "react";
import { ProviderHubContext } from "@app/projects/network-assessment/provider-hub/contexts/ProviderHubContext";
import FlyoutLink from "@app/shared/Flyouts/FlyoutLink";
import { QESButtonTypeClasses } from "@app/shared/qes-standards/Button";
import { KeyPointsFlyout } from "@app/projects/network-assessment/provider-hub/provider-profile/KeyPointsFlyout";
import { AccessGapTypeEnum } from "@app/projects/network-assessment/provider-hub/enumerators";
import { GapRegionStatusAnnotation } from "@app/projects/network-assessment/provider-hub/GapRegionStatusAnnotation";

export const ProviderProfileKeyPoints: FC = () => {
  const providerHubContext = useContext(ProviderHubContext);
  const { selectedProvider } = providerHubContext;

  return (
    <div className="provider-profile__card">
      <h4 className="provider-profile__card-title">Key Points</h4>
      <div className="provider-profile__card-content">
        <div className="provider-profile__card-values">
          <div className="provider-profile__card-highlight" aria-labelledby="access-points">{selectedProvider.accessPointCount}</div>
          <div className="provider-profile__card-highlight" aria-labelledby="counties-served">{selectedProvider.regionSetServed}</div>
          <div className="provider-profile__card-highlight" aria-labelledby="closes-gaps">
            {!selectedProvider.gapsClosed
              ? (selectedProvider.gapsClosed === 0 ? selectedProvider.gapsClosed : "---")
                : (
                    <FlyoutLink
                      classNames={QESButtonTypeClasses.get("link")}
                      testId="provider-profile__closes-gaps"
                      content={{
                        body: <KeyPointsFlyout gapType={AccessGapTypeEnum.FillableBySingleProvider} />,
                        title: "Gap Closure"
                      }}>
                        {selectedProvider.gapsClosed}
                    </FlyoutLink>
                  )
            }
            <GapRegionStatusAnnotation
              total={selectedProvider.gapsClosed}
              active={selectedProvider.activeGapsClosed}
              pending={selectedProvider.pendingGapsClosed}
              approved={selectedProvider.approvedGapsClosed}
              opportunity={selectedProvider.opportunityGapsClosed}
              useGapsByRegionStatus={selectedProvider.useGapsByRegionStatus}
            />
          </div>
          <div className="provider-profile__card-highlight" aria-labelledby="increase-access">
            {!selectedProvider.gapsIncreaseAccess
              ? (selectedProvider.gapsIncreaseAccess === 0 ? selectedProvider.gapsIncreaseAccess : "---")
                : (
                    <FlyoutLink
                      classNames={QESButtonTypeClasses.get("link")}
                      testId="provider-profile__increases-access"
                      content={{
                        body: <KeyPointsFlyout gapType={AccessGapTypeEnum.PartiallyFillableGap} />,
                        title: "Increases Access (No Gap Closure)"
                      }}
                    >
                      {selectedProvider.gapsIncreaseAccess}
                    </FlyoutLink>
                  )
            }
            <GapRegionStatusAnnotation
              total={selectedProvider.gapsIncreaseAccess}
              active={selectedProvider.activeGapsIncreaseAccess}
              pending={selectedProvider.pendingGapsIncreaseAccess}
              approved={selectedProvider.approvedGapsIncreaseAccess}
              opportunity={selectedProvider.opportunityGapsIncreaseAccess}
              useGapsByRegionStatus={selectedProvider.useGapsByRegionStatus}
              testId="provider-profile__increases-access-gap-region-status"
            />
          </div>
        </div>

        <div className="provider-profile__card-labels">
          <div className="provider-profile__card-subtitle" id="access-points">Access Points</div>
          <div className="provider-profile__card-subtitle" id="counties-served">Counties Served</div>
          <div className="provider-profile__card-subtitle" id="closes-gaps">Closes Gaps</div>
          <div className="provider-profile__card-subtitle" id="increase-access">Increase Access</div>
        </div>
      </div>
    </div>
  );
};